import { render, staticRenderFns } from "./ProjectBudget.vue?vue&type=template&id=137d4e05&scoped=true"
import script from "./ProjectBudget.vue?vue&type=script&lang=js"
export * from "./ProjectBudget.vue?vue&type=script&lang=js"
import style0 from "./ProjectBudget.vue?vue&type=style&index=0&id=137d4e05&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137d4e05",
  null
  
)

export default component.exports